/* @flow */
import Fieldset from 'components/Fieldset.jsx';
import Group from 'entities/Group';
import React from 'react';
import RelationshipViewGroupListItem from 'user/components/RelationshipViewGroupListItem.jsx';
import Subscriber from 'entities/Subscriber';
import Subscription from 'entities/Subscription';

class RelationshipViewGroupList extends React.Component {
  static propTypes = {
    legend: React.PropTypes.string.isRequired,
    groupSubscriptions: React.PropTypes.arrayOf(React.PropTypes.shape({
      group: React.PropTypes.instanceOf(Group).isRequired,
      subscription: React.PropTypes.instanceOf(Subscription), // to the group
    })).isRequired,
  };

  static contextTypes = {
    subscriber: React.PropTypes.instanceOf(Subscriber).isRequired,
  };

  render() {
    return (
      <Fieldset legend={this.props.legend} size="small">
        {this.props.groupSubscriptions.map(({ group, subscription }) => (
          <RelationshipViewGroupListItem
            key={group.id}
            group={group}
            subscriber={this.context.subscriber}
            subscription={subscription}
          />
        ))}
        {this.props.children}
      </Fieldset>
    );
  }
}

export default RelationshipViewGroupList;



// WEBPACK FOOTER //
// ./src/user/components/RelationshipViewGroupList.jsx